import { render, staticRenderFns } from "./ProjectsList.vue?vue&type=template&id=141d07f1&scoped=true"
import script from "./projectsList.ts?vue&type=script&lang=ts&external"
export * from "./projectsList.ts?vue&type=script&lang=ts&external"
import style0 from "./ProjectsList.vue?vue&type=style&index=0&id=141d07f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141d07f1",
  null
  
)

export default component.exports